__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/6a74283/_next/";